// Thư mục: src/stores/dmHangMucBaoDuongStore.js
import { defineStore } from "pinia";
import { DmHangMucBaoDuongApi } from "@/services/dmHangMucBaoDuongService";

export const useDmHangMucBaoDuongStore = defineStore("dmHangMucBaoDuong", {
  state: () => ({
    isLoading: false, // Loading chung
    error: null, // Lỗi chung
    items: [], // Danh sách hạng mục (phân trang)

    // State phân trang và tìm kiếm
    q: "", // Từ khóa tìm kiếm
    page: 0, // Trang hiện tại (0-based backend)
    size: 10, // Kích thước trang
    sort: "tenHangMuc,asc", // Sắp xếp mặc định
    totalPages: 1,
    totalElements: 0,

    // State cho options dropdown (ví dụ dùng khi tạo Lịch Bảo Dưỡng Xe)
    activeOptions: [],
    isLoadingOptions: false,
  }),

  getters: {
    // Trang hiện tại (1-based) cho UI
    currentPage(state) {
      return state.page + 1;
    },
  },

  actions: {
    // --- Actions Phân trang & Tìm kiếm ---
    setQuery(keyword) {
      this.q = keyword;
      this.page = 0; // Reset về trang đầu khi tìm kiếm
    },
    setPage(p1) {
      const p0 = Math.max(0, p1 - 1); // Đảm bảo >= 0
      if (p0 !== this.page) this.page = p0;
    },
    setSize(s) {
      this.size = s;
      this.page = 0; // Reset về trang đầu khi đổi size
    },
    // (Có thể thêm setSort nếu cần)

    // --- Action Tải Danh sách Hạng mục ---
    async fetchList() {
      this.isLoading = true;
      this.error = null;
      try {
        const data = await DmHangMucBaoDuongApi.search({
          // Gọi hàm search mới
          q: this.q,
          page: this.page,
          size: this.size,
          sort: this.sort,
        });
        // items là DmHangMucBaoDuongResponse
        this.items = data.content || [];
        this.totalPages = data.totalPages ?? 1;
        this.totalElements = data.totalElements ?? this.items.length;
        this.page = data.number ?? 0;
        this.size = data.size ?? this.size;
      } catch (e) {
        this.error =
          e?.response?.data?.message ||
          e?.message ||
          "Lỗi tải danh mục hạng mục bảo dưỡng";
        console.error("fetchList DmHangMucBaoDuong error:", e);
        // Reset state nếu lỗi
        this.items = [];
        this.totalPages = 1;
        this.totalElements = 0;
      } finally {
        this.isLoading = false;
      }
    },

    // --- Action Tải Options ---
    async fetchActiveOptionsIfNeeded() {
      if (this.activeOptions.length > 0) return; // Chỉ tải 1 lần
      this.isLoadingOptions = true;
      try {
        const data = await DmHangMucBaoDuongApi.listActiveOptions();
        this.activeOptions = data || [];
      } catch (e) {
        console.error("Lỗi tải options hạng mục bảo dưỡng:", e);
        this.activeOptions = []; // Reset nếu lỗi
      } finally {
        this.isLoadingOptions = false;
      }
    },

    // --- Actions CRUD Hạng mục ---
    // Nhận vào DmHangMucBaoDuongRequest
    async createHangMuc(form) {
      this.loading = true; // Bật loading chung
      this.error = null;
      try {
        await DmHangMucBaoDuongApi.create(form);
        await this.fetchList(); // Tải lại list
      } catch (e) {
        this.error =
          e?.response?.data?.message || e?.message || "Lỗi tạo hạng mục";
        console.error("createHangMuc error:", e);
        throw e; // Ném lỗi ra để component xử lý (vd: hiển thị alert)
      } finally {
        this.loading = false; // Tắt loading chung
      }
    },

    // Nhận vào DmHangMucBaoDuongRequest
    async updateHangMuc(id, form) {
      this.loading = true;
      this.error = null;
      try {
        await DmHangMucBaoDuongApi.update(id, form);
        await this.fetchList();
      } catch (e) {
        this.error =
          e?.response?.data?.message || e?.message || "Lỗi cập nhật hạng mục";
        console.error("updateHangMuc error:", e);
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async deleteHangMuc(id) {
      this.loading = true;
      this.error = null;
      try {
        await DmHangMucBaoDuongApi.remove(id);
        // Logic lùi trang nếu cần
        if (this.items.length === 1 && this.page > 0) {
          this.page -= 1;
        }
        await this.fetchList();
      } catch (e) {
        this.error =
          e?.response?.data?.message || e?.message || "Lỗi xóa hạng mục";
        console.error("deleteHangMuc error:", e);
        throw e;
      } finally {
        this.loading = false;
      }
    },
  },
});
